export enum PieLabelPosition {
  Inside = 'inside',
  Outside = 'outside',
  Center = 'center',
  Inner = 'inner',
}

export interface LabelLine {
  show: boolean;
  // To be implemented
  // lineStyle: {
  //   color: string,
  //   width: number,
  //   type: string,
  //   dashOffset: number,
  //   cap: string,
  //   join: string,
  //   miterLimit: number,
  //   shadowBlur: string,
  //   shadowColor: string,
  //   shadowOffsetX: number,
  //   shadowOffsetY: number,
  //   opacity: string,
}
